module.exports = __webpack_public_path__ + "img/BAU Seniors_16.f44f28e4.jpg";